import { Button, Col, Row, Space, Alert, Tabs } from 'antd';
import { Input } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import MapsAdministrationComponent from './administrationComponents/MapsAdministrationComponent';
import LayersAdministrationComponent from './administrationComponents/LayersAdministrationComponent';
import ToolsAdministrationComponent from './administrationComponents/ToolsAdministrationComponent';
import URSAdministrationComponent from './administrationComponents/URSAdministrationComponent';
import { MapService } from "../../service/mapService";
import { RoleService } from '../../service/rolService';

import { user_state } from '../../features/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { UserService } from '../../service/userService';
import { SecurityService } from '../../service/securityService';
import RoleManager from './v2/RoleManager';
import SrvSecManager from './v2/SrvSecManager';
import UserManager from './v2/UserManager';
import MapToolManager from './v2/MapToolManager';
import MapLayerManager from './v2/MapLayerManager';
import MapManager from './v2/MapManager';
import RoleMapManager from './v2/RoleMapManager';
import MapLayerSrvSecManager from './v2/MapLayerSrvSecManager';
import MapLayerAssociationManager from './v2/MapLayerAssociationManager';
import MapToolServiceManager from './v2/MapToolServiceManager';
import UserRoleManager from './v2/UserRoleManager';
import MapToolAssociationManager from './v2/MapToolAssociationManager';


const { TextArea } = Input;

const AdministradorComponentV2 = () => {


    const tabItems = [
      { key: '1', label: 'RoleManager', component: <RoleManager /> },
      { key: '2', label: 'SrvSecManager', component: <SrvSecManager /> },
      { key: '3', label: 'UserManager', component: <UserManager /> },
      { key: '4', label: 'MapToolManager', component: <MapToolManager /> },
      { key: '5', label: 'MapLayerManager', component: <MapLayerManager /> },
      { key: '6', label: 'MapManager', component: <MapManager /> },
      { key: '7', label: 'RoleMapManager', component: <RoleMapManager /> },
      { key: '8', label: 'UserRoleManager', component: <UserRoleManager /> },
      { key: '9', label: 'MapLayerSrvSecManager', component: <MapLayerSrvSecManager /> },
      { key: '10', label: 'MapLayerAssociationManager', component: <MapLayerAssociationManager /> },
      { key: '11', label: 'MapToolAssociationManager', component: <MapToolAssociationManager /> },
      { key: '12', label: 'MapToolServiceManager', component: <MapToolServiceManager /> },
    ];

    return (
      <div style={{ marginTop: '50px', marginLeft: '10px', marginRight: '10px' }}>
      <Tabs>
        {tabItems.map(tab => (
        <Tabs.TabPane tab={tab.label} key={tab.key}>
          {tab.component}
        </Tabs.TabPane>
        ))}
      </Tabs>
      </div>
    );
}

export default AdministradorComponentV2;